<template>
  <div class="convention-hall page" style="width: 100%; padding-bottom: 4.33333rem; background: url('/img/home/g.f7e76bcc.png') center top / 100% repeat;">
    <van-nav-bar class="nav-bar" :title="$t('foorter.benefits')"></van-nav-bar>

    <div class="data" style="width: 100%;">
      <!-- Item 1: Member Video -->
      <div class="items" style="display: flex; justify-content: space-between; align-items: center; padding: 0px 10.6667px; margin: 0px 17.6094px 16px 17.5938px; background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8)); height: 64px; border-radius: 8px;">
        <div style="display: flex; align-items: center;" @click="goVideo()">
          <img src="/img/footer/ys1.png" style="width: 30px; height: 30px;" />
          <span style="color: rgb(255, 255, 255); margin-left: 0.33333rem; font-size: 0.93333rem;"> {{ $t('foorter.top16') }}</span>
        </div>
        <div style="display: flex; align-items: center;" @click="goService()">
          <span style="color: rgb(255, 255, 255); font-size: 0.8rem; margin-right: 0.33333rem;">{{ $t('foorter.top17') }}</span>
          <div style="position: relative; display: inline-block;">
            <div style="margin-left: 0.33333rem; color: rgb(153, 153, 153); font-size: 32px;">
              <img src="/img/home/cs.png" style="display: block; width: 32px; height: 32px; object-fit: contain;" />
            </div>
            <div style="position: absolute; width: 8px; min-width: 0px; height: 8px; background: rgb(238, 10, 36); border-radius: 100%; padding: 0px; top: 0px; left: 34px;"></div>
          </div>
          <i class="van-icon van-icon-arrow" style="margin-left: 5px; color: #fff;"></i>
        </div>
      </div>

      <!-- Item 2: Benefits -->
      <div class="items" style="display: flex; justify-content: space-between; align-items: center; padding: 0px 10.6667px; margin: 0px 17.6094px 16px 17.5938px; background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8)); height: 64px; border-radius: 8px;" @click="goBenefits()">
        <div style="display: flex; align-items: center;" >
          <img src="/img/footer/fl1.png" style="width: 30px; height: 30px;" />
          <span style="color: rgb(255, 255, 255); margin-left: 0.33333rem; font-size: 0.93333rem;"> {{ $t('foorter.benefits') }}</span>
        </div>
        <div style="display: flex; align-items: center;">
          <span style="color: rgb(255, 255, 255); font-size: 0.8rem; margin-right: 0.33333rem;">{{ $t('foorter.top18') }}:{{ newMemberId || '232***' }}</span>
          <div style="position: relative; display: inline-block;">
            <div style="margin-left: 0.33333rem; color: rgb(153, 153, 153); font-size: 32px;">
              <img src="/img/home/cs.png" style="display: block; width: 32px; height: 32px; object-fit: contain;" />
            </div>
            <div style="position: absolute; width: 8px; min-width: 0px; height: 8px; background: rgb(238, 10, 36); border-radius: 100%; padding: 0px; top: 0px; left: 34px;"></div>
          </div>
          <i class="van-icon van-icon-arrow" style="margin-left: 5px; color: #fff;"></i>
        </div>
      </div>
    </div>

    <!-- Card list -->
    <div style="box-sizing: border-box; width: 100%;">
      <div style="width: 92%; margin: 0px auto; padding-bottom: 4rem;">
        <ul class="ddd" style="width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: flex-start;">
          <li v-for="(item, index) in gameitemData" :key="index" @click="toDetail(item.id, item.key)" style="width: 100%; height: 144px; background: url('/img/home/g1.png') no-repeat center / 100%; border-radius: 10.6667px; margin-bottom: 10.6667px; display: flex; flex-direction: column;" :style="{ background: index % 2 === 1 ? 'url(\'/img/home/g2.png\') no-repeat center / 100%' : 'url(\'/img/home/g1.png\') no-repeat center / 100%' }">
            <div class="ddd1" style="align-items: center; line-height: 32px;">
              <img src="/img/home/qy.png" style="display: block; width: 16px; height: 16px; object-fit: contain;" />
              {{ $t('foorter.top19') }}
            </div>
            <p style="font-size: 0.93333rem; font-weight: 600; color: rgb(61, 70, 81); text-align: left; margin-top: 1.66667rem; margin-left: 1.66667rem;">{{ item.name }}</p>
          </li>
          <!-- Fallback cards if no data -->
          <li v-if="gameitemData.length === 0" style="width: 100%; height: 144px; background: url('/img/home/g1.png') no-repeat center / 100%; border-radius: 10.6667px; margin-bottom: 10.6667px; display: flex; flex-direction: column;">
            <div class="ddd1" style="align-items: center; line-height: 25px;">
              <img src="/img/home/qy.png" style="display: block; width: 16px; height: 16px; object-fit: contain;" />
              {{ $t('foorter.top19') }}
            </div>
            <p style="font-size: 0.93333rem; font-weight: 600; color: rgb(61, 70, 81); text-align: left; margin-top: 1.66667rem; margin-left: 1.66667rem;">Authentication data①</p>
          </li>
          <li v-if="gameitemData.length === 0" style="width: 100%; height: 144px; background: url('/img/home/g2.png') no-repeat center / 100%; border-radius: 10.6667px; margin-bottom: 10.6667px; display: flex; flex-direction: column;">
            <div class="ddd1" style="align-items: center; line-height: 25px;">
              <img src="/img/home/qy.png" style="display: block; width: 16px; height: 16px; object-fit: contain;" />
              {{ $t('foorter.top19') }}
            </div>
            <p style="font-size: 0.93333rem; font-weight: 600; color: rgb(61, 70, 81); text-align: left; margin-top: 1.66667rem; margin-left: 1.66667rem;">Authentication data②</p>
          </li>
          <li v-if="gameitemData.length === 0" style="width: 100%; height: 144px; background: url('/img/home/g1.png') no-repeat center / 100%; border-radius: 10.6667px; margin-bottom: 10.6667px; display: flex; flex-direction: column;">
            <div class="ddd1" style="align-items: center; line-height: 25px;">
              <img src="/img/home/qy.png" style="display: block; width: 16px; height: 16px; object-fit: contain;" />
              {{ $t('foorter.top19') }}
            </div>
            <p style="font-size: 0.93333rem; font-weight: 600; color: rgb(61, 70, 81); text-align: left; margin-top: 1.66667rem; margin-left: 1.66667rem;">Authentication data③</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- Hidden convention item (matching target) -->
    <div class="convention-item" style="display: none;">
      <div class="left">
        <van-sidebar v-model="activeSidebar" @change="onChangeSidebar">
          <van-sidebar-item :title="$t('index.all')" />
          <van-sidebar-item v-for="(item, index) in gameitemData" :key="index" :title="item.name" />
        </van-sidebar>
      </div>
    </div>

    <div style="padding-bottom: 35px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeSidebar: 0,
      gameitemData: [],
      newMemberId: ''
    };
  },
  methods: {
    onChangeSidebar(index) {
      this.activeSidebar = index;
    },

    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        if (res.code === 200) {
          this.gameitemData = res.data || [];
        }
      }).catch(() => {
        this.gameitemData = [];
      });
    },

    toDetail(id, key) {
      this.$router.push({ path: "/lottery", query: { id: id, key: key } });
    },

    goVideo() {
      this.$router.push({ path: '/Video' });
    },

    goBenefits() {
      this.$router.push({ path: '/welfare' });
    },

    goService() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/ServiceOnline' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    }
  },
  created() {
    this.getGameItem();
  }
};
</script>

<style scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-bar {
  background: transparent !important;
}

::v-deep .van-nav-bar__content {
  background: transparent !important;
}

::v-deep .van-nav-bar__title {
  color: #000;
}

.ddd1 {
  display: flex;
  padding: 0px;
  color: #fff;
  font-size: 20px;
}
</style>
